module.exports = __webpack_public_path__ + "static/media/pbg.2de44041.svg";